<div class="promo-card border border-radius-m">
    <ng-container *ngIf="template">
    <a
         href="{{ template.link }}"
        [attr.aria-label]="template.heading"
        target="_blank"
        data-testid="promo-unit">
        <div class="header flex">
            <h5>{{template.heading}}</h5>
            <p class="subheading text-dark text-size-s">
                {{template.subheading}}
            </p>
        </div>
        <div [innerHTML]="template.svg"></div>
    </a>
    </ng-container>
</div>
